import { SxProps } from '@mui/material';

export const style: SxProps = {
  top: 'auto',
  right: 10,
  bottom: 25,
  left: 'auto',
  position: 'fixed',
  zIndex: 1000,
};
